import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import {
  type AutomationRunSessionOpenedLocation,
  type AutomationsAnalyticsRunStatus,
  withAutomationsCategory,
} from './automationsAnalytics';
import META from './useTrackAutomationRunSessionOpened.meta';

export type UseTrackAutomationRunSessionOpenedParams = {
  automation_id: string;
  run_status: AutomationsAnalyticsRunStatus;
  location: AutomationRunSessionOpenedLocation;
};

export const useTrackAutomationRunSessionOpened = () => {
  const { track } = useAnalyticsUtilities();

  const trackAutomationRunSessionOpened = useCallback(
    (params: UseTrackAutomationRunSessionOpenedParams) => {
      track(META.name, withAutomationsCategory(params));
    },
    [track],
  );

  return { trackAutomationRunSessionOpened };
};
